import gql from 'graphql-tag'

export const GET_CATEGORY_LINK_BY_PATH = gql`
  query GetCategoryLinkByPath($categoryPath: String!) {
    categoryByPath(categoryPath: $categoryPath) {
      name
      pathSlug
      mostPopularProduct {
        searchResultProduct {
          displayName
          primaryImageId
        }
      }
    }
  }
`
